var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.267 15.893.243.437-.243-.437zm.337-.055.086-.493-.086.493zm-3.043 1.559-.243-.437.243.437zM5.1 14.52l.266-.423-.266.423zM18.5 9.5c0 1.606-.85 3.095-2.293 4.199-1.444 1.104-3.46 1.801-5.707 1.801v1c2.447 0 4.681-.758 6.314-2.007 1.634-1.249 2.686-3.01 2.686-4.993h-1zm-8-6c2.247 0 4.263.697 5.707 1.801C17.65 6.405 18.5 7.894 18.5 9.5h1c0-1.983-1.052-3.744-2.686-4.993C15.181 3.258 12.947 2.5 10.5 2.5v1zm-8 6c0-1.606.85-3.095 2.293-4.199C6.237 4.197 8.253 3.5 10.5 3.5v-1c-2.447 0-4.681.758-6.314 2.007S1.5 7.517 1.5 9.5h1zm2.866 4.597C3.58 12.97 2.5 11.307 2.5 9.5h-1c0 2.236 1.335 4.184 3.333 5.443l.533-.846zm-.048 2.863.492-1.723-.961-.275-.493 1.723.962.275zm2.706-1.504L5.318 16.96l.486.874L8.51 16.33l-.486-.874zm2.476.044c-.623 0-1.229-.054-1.81-.155l-.172.985c.638.112 1.302.17 1.982.17v-1zm-1.99.83h.008l.172-.985a1.012 1.012 0 0 0-.666.111l.486.874zm-4.154.355c-.244.857.669 1.582 1.448 1.149l-.486-.874-.962-.275zm.477-1.742a.035.035 0 0 1 .014.016l.002.004.961.274a1.02 1.02 0 0 0-.444-1.14l-.533.846z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuKakao);
export default __webpack_public_path__ + "static/media/menu_kakao.f9426743b1e71a0e689b3690621eacc7.svg";
export { ForwardRef as ReactComponent };